import { render, staticRenderFns } from "./PerfDesign.vue?vue&type=template&id=4f8107bf"
import script from "./PerfDesign.vue?vue&type=script&lang=js"
export * from "./PerfDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports